<template>
    <!-- 账号列表 -->
    <div>
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-date-picker v-model="date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="最近登录开始时间" end-placeholder="最近登录结束时间">
                </el-date-picker>
            </div>
            <div class="conditionItem">
                <el-select v-model="params.condition.roletype" placeholder="角色类型" clearable>
                    <el-option v-for="item in roletypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                </el-select>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.loginname" placeholder="登录帐号" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.nickname" placeholder="帐号昵称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-input v-model="params.condition.name" placeholder="真实姓名" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div class="mb-15">
            <el-button type="primary" icon="el-icon-plus" @click="openAddAccountDialog('')">新增帐号</el-button>
        </div>
        <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" ref="table">
            <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                <template slot-scope="scope">
                    <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                </template>
            </el-table-column>
            <el-table-column prop="nickname" label="账号昵称" align="center" min-width="200" key="nickname" fixed show-overflow-tooltip>
                <template slot-scope="scope">
                    <div class="flex al-c">
                        <img class="img" :src="scope.row.logourl ? scope.row.logourl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" alt="">
                        <p style="line-height:40px;" class="text-ellipse">{{scope.row.nickname}}</p>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="loginname" label="登录账号" align="center" width="150" key="loginname" fixed show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="roletypename" label="角色类型" align="center" width="100" key="roletypename" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="真实姓名" align="center" width="100" key="name" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="telno" label="手机号码" align="center" width="150" key="telno" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="campusname" label="校区权限" align="center" min-width="150" key="campusname" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="recentlogintime" label="最后登录时间" align="center" width="200" key="recentlogintime" show-overflow-tooltip :formatter="formatTab">
                <template slot-scope="scope">
                    <p>{{scope.row.recentlogintime ? scope.row.recentlogintime : '--'}}</p>
                    <p>{{scope.row.ipaddress}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="label" label="所属标签" align="center" width="200" key="label" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="memo" label="说明" align="center" min-width="200" key="memo" show-overflow-tooltip :formatter="formatTab">
            </el-table-column>
            <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton2()" key="edit">
                <template slot-scope="scope">
                    <div class="color-brand flex jc-sa ai-c pointer">
                        <p @click="openAddAccountDialog(scope.row.code)">编辑</p>
                        <p @click="deleteAccount(scope.row.code)">删除</p>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        <AddAccountDialog ref="AddAccountDialog" @saveSuccess="search"></AddAccountDialog>
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import { getAccountList, deleteAccount } from '@/api/measApi/systemManage.js'
import AddAccountDialog from './components/addAccountDialog.vue'
export default {
  data() {
    return {
      isSelect: false,
      date: [],
      params: {
        condition: {
          loginname: '',
          name: '',
          nickname: '',
          recentlogintimeend: '',
          recentlogintimestart: '',
          roletype: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      //   角色类型：1超级管理员、2校区操作员、11学员
      roletypeList: [
        {
          value: 1,
          label: '超级管理员'
        },
        {
          value: 2,
          label: '校区操作员'
        },
        {
          value: 11,
          label: '学员'
        }
      ],
      tableData: [],
      total: 0,
      contentLoading: false
    }
  },
  components: {
    TableSort,
    Page,
    AddAccountDialog
  },
  created() {
    this.getAccountList()
  },
  methods: {
    //   获取账号列表
    getAccountList() {
      this.contentLoading = true
      if (this.date && this.date.length > 0) {
        this.params.condition.recentlogintimestart = this.date[0]
        this.params.condition.recentlogintimeend = this.date[1]
      } else {
        this.params.condition.recentlogintimeend = ''
        this.params.condition.recentlogintimestart = ''
      }
      getAccountList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getAccountList()
    },
    // 重置
    reset() {
      this.date = []
      this.params = {
        condition: {
          loginname: '',
          name: '',
          nickname: '',
          recentlogintimeend: '',
          recentlogintimestart: '',
          roletype: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getAccountList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getAccountList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getAccountList()
    },
    // 初始化表格
    formatTab(row, column, value) {
      return value ? value : '--'
    },
    // 添加帐号
    openAddAccountDialog(code) {
      this.$refs.AddAccountDialog.handleOpen(code)
    },
    // 删除
    deleteAccount(code) {
      this.$confirm('确定删除该账号吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          deleteAccount({ code: code }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getAccountList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-left: 20px;
  margin-right: 10px;
}
</style>

